module.exports = __webpack_public_path__ + "fb4a7936dc29546ef7d6c9232c3b2fa1.png";